<div class="modal fade p-0" tabindex="-1" role="dialog" id="modal">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content" [ngStyle]="{ 'background-image': 'url( ' + content.imgLateral + ')' }">
      <div class="modal-body py-5">
        <button type="button" class="btn-close mdc-close" data-bs-dismiss="modal" aria-label="Close"
          *ngIf="content.closeB && content.closeB != 'home'"></button>
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-6 ms-auto my-5 text-center">
              <img *ngIf="content.imgMobile" src="{{ content.imgMobile }}"
                class="d-block d-lg-none mdc-icon-asesor m-auto" alt="asesor" appLazyLoadImg>
              <p class="titulo mt-3 mt-lg-0"
                [ngClass]="{'mdc-text-secondary': content.tipo === 'ok', 'mdc-text-pink': content.tipo === 'bad'}">
                {{ content.titulo }}
              </p>
              <p class="mdc-text-gray mdc-text-4 my-5" [innerHTML]="content.textoHTML">
              </p>
              <a *ngIf="content.enlace" class="btn w-75 text-white" (click)="content.close()"
                [routerLink]="content.enlaceBoton"
                [ngClass]="{'mdc-btn-primary': content.tipo === 'ok', 'mdc-btn-pink': content.tipo === 'bad'}">
                {{ content.textBoton }}
                <i class="fa fa-chevron-right mt-1"></i>
              </a>
              <button *ngIf="!content.enlace && !content.enlaceExterno" (click)="content.close()" class="btn w-75"
                type="button"
                [ngClass]="{'mdc-btn-primary': content.tipo === 'ok', 'mdc-btn-pink': content.tipo === 'bad'}">
                {{ content.textBoton }}
                <i class="fa fa-chevron-right mt-1"></i>
              </button>
              <a *ngIf="content.enlaceExterno" class="btn w-75 text-white" (click)="content.close()"
                [href]="content.enlaceExterno"
                [ngClass]="{'mdc-btn-primary': content.tipo === 'ok', 'mdc-btn-pink': content.tipo === 'bad'}">
                {{ content.textBoton }}
                <i class="fa fa-chevron-right mt-1"></i>
              </a>
              <a *ngIf="content.closeB === 'home'" (click)="content.close()" routerLink="/private/historico"
                class="text-center d-block m-auto pt-2 link mdc-text-secondary" style="cursor: pointer;">
                - Ir a inicio -
              </a>
            </div>
            <div class="col-lg-6 ms-auto">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Plan Perfil de Crédito -->
<div class="modal fade hide" id="planPerfilModal" tabindex="-1" role="dialog" aria-labelledby="planPerfilModalLabel"
  aria-hidden="true" *ngIf="sesion.planes.planes">
  <div class="modal-dialog plansModal modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="container">
          <div class="row">
            <div class="col-12 col-md-6 order-0 order-md-0 mb-3 align-self-center">
              <img src="assets/img/modals/plans-freemium/Compra_premium.svg" class="img-plan" alt="Plan Freemium"  appLazyLoadImg/>
            </div>
            <div class="col-12 col-md-6 order-1 order-md-1">
              <p class="title-plan">{{ sesion.planes.planes.per.popup }}</p>
              <p class="price">${{ sesion.planes.planes.per.mensual[0] }}<span>/ mes</span></p>
              <p class="add">Adicional a los beneficios del <span>PLAN FREEMIUM</span> recibe:</p>
              <div class="bullets">
                <div class="completeBullet" *ngFor="let item of sesion.planes.planes?.per?.itemsV2">
                  <i class="fa fa-check" aria-hidden="true"></i>
                  <p class="regular">{{item.txt}}</p>
                </div>
              </div>
              <a (click)="seleccionarPlan(sesion.planes.planes.per, '1', sesion.planes.planes.per.mensual[1], sesion.planes.planes.per.mensual[0])"
                class="btn-midc btn-orange h-lg-btn w-100-btn" id="planPerfilCreditoModal" webActivity
                data-idtag="Freemium" data-nametag="planPerfilCreditoModal" data-bs-dismiss="modal" aria-label="Close">
                <span>Adquirir plan</span>
                <i class="fa fa-chevron-right" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Modal Plan Perfil de Crédito -->

<!-- Modal Reclamaciones  -->
<div class="modal fade hide" id="claimModal" tabindex="-1" role="dialog" aria-labelledby="claimModalLabel"
  aria-hidden="true">
  <div class="modal-dialog claimsModal modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"> </button>
      </div>
      <div class="modal-body">
        <div class="container">
          <div class="row">
            <div class="col-12 col-md-6 align-self-center">
              <img src="assets/img/modals/alert-claims/Tips.svg" alt="Alerta Notificaciones" class="img-claim"  appLazyLoadImg/>
            </div>
            <div class="col-12 col-md-6">
              <p class="title-modal">Antes de formular un reclamo le recomendamos leer la siguiente información</p>
              <div class="box">
                <div class="box-scroll" (scroll)="checkScrollReclamation()">
                  <div class="scroll-check-claim">
                    <ol>
                      <li>La actualización de la información reportada por las fuentes se ve reflejada de manera mensual
                        en tu historia de crédito. Así mismo, es viable que la actualización de los reportes de
                        información lo realice la entidad (fuente) mes vencido.</li>
                      <li>En el caso de datos negativos, que son aquellos cuyo contenido hacen referencia al tiempo de
                        mora, tipo de cobro, estado de la cartera, y en general, aquellos datos referentes a una
                        situación
                        de incumplimiento de obligaciones se regirán por un término máximo de permanencia. Si deseas ver
                        más información sobre este tema de permanencia por favor dirígete a nuestro portal en la Sección
                        Habeas Data, donde encontrará más detalles, tips y documentos de ley existentes que hoy nos
                        rigen.
                      </li>
                      <li>Los detalles que registres sobre tu reclamo son vitales para el estudio de tu solicitud, por
                        favor regístralos en el campo de observaciones.</li>
                      <li>Al realizar tu reclamo por favor ten en cuenta que la aplicación te va a exigir “tipo” y
                        “subtipo” de reclamo los cuales deben ser en lo posible los más exactos frente a la novedad que
                        estás solicitando.</li>
                      <li>Si tienes varios productos con la entidad (fuente) verifica que el reclamo esté siendo
                        registrado en la obligación o producto correcto.</li>
                      <li>Ten en cuenta que la información positiva (datos referentes al cumplimiento de obligaciones)
                        pueden permanecer de manera indefinida en la base de datos del Operador DataCredito.</li>
                      <li>La venta de cartera que realicen las diferentes entidades o fuentes de DataCrédito, puede
                        conducir a que tu obligación ahora aparezca registrada por una nueva entidad (acreedor actual de
                        la obligación), caso en el cual la entidad actual que reporta la obligación en DataCrédito puede
                        informarte sobre las condiciones de la obligación y demás datos relacionados con la misma.</li>
                    </ol>
                  </div>
                  <div>
                    <button target="_blank" class="btn-midc btn-orange h-lg-btn w-100-btn d-block d-md-none" (click)=formularReclamacion()
                      id="generarReclamacion" data-bs-dismiss="modal" aria-label="Close">
                      <span>Generar reclamación</span>
                    </button>
                  </div>
                </div>
              </div>
              <button target="_blank" class="btn-midc btn-orange h-lg-btn w-100-btn d-none d-md-block" (click)=formularReclamacion()
                id="generarReclamacion" data-bs-dismiss="modal" aria-label="Close" [disabled]="scrollCheck">
                <span>Generar reclamación</span>
                <i class="fa fa-chevron-right" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Modal Reclamaciones  -->

<!-- Modal Creacion Reclamacion -->
<div class="modal fade hide" id="okReclamacionModal" tabindex="-1" role="dialog" aria-labelledby="okReclamacionModal"
  aria-hidden="true">
  <div class="modal-dialog okReclamacion modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="container">
          <div class="row">
            <div class="col-12 col-md-6 align-self-center">
              <img src="assets/img/modals/alert-claims/ok-reclamacion.svg" alt="Alerta Notificaciones"
                class="img-claim" appLazyLoadImg/>
            </div>
            <div class="col-12 col-md-6">
              <p class="title-reclamacion">Tu Reclamación ha sido creada con éxito.</p>
              <div class="box">
                <p>
                  Datacrédito Experian se encargará de tramitar tu reclamación ante la entidad respectiva.
                </p>
              </div>
              <a target="_blank" class="btn-midc btn-orange h-lg-btn w-100-btn" (click)="salirReclamacion()"
                id="generarReclamacionn" data-bs-dismiss="modal" aria-label="Close">
                <span>Ver mis reclamaciones</span>
                <i class="fa fa-chevron-right" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Modal Creacion Reclamacion -->


<!-- Modal Verifica -->
<div class="modal fade hide" id="modalVerifica" tabindex="-1" role="dialog" aria-labelledby="planPerfilModalLabel"
  aria-hidden="true">
  <div class="modal-dialog plansModal modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="container">
          <div class="row">
            <div class="col-12 col-md-6 order-0 order-md-0 mb-3 align-self-center">
              <img src="assets/img/modals/alert-claims/Banner_verifica.svg" class="img-plan" alt="Plan Freemium"  appLazyLoadImg/>
            </div>
            <div class="col-12 col-md-6 order-1 order-md-1">
              <p class="title-verifica">Verifica a otra persona en Mi Datacrédito</p>
              <p class="add"><b>Verifica</b> te ayudará a obtener la <b>confianza</b> y la <b>tranquilidad</b> de saber
                con quién estás negociando.</p>
              <p class="price">$19.900</p>
              <div class="bullets">
                <div class="completeBullet">
                  <i class="fa fa-check" aria-hidden="true"></i>
                  <p class="regular">Validación de identidad de la persona consultada.</p>
                </div>
                <div class="completeBullet">
                  <i class="fa fa-check" aria-hidden="true"></i>
                  <p class="regular">Nivel de confianza de la persona consultada.</p>
                </div>
                <div class="completeBullet">
                  <i class="fa fa-check" aria-hidden="true"></i>
                  <p class="regular">Validación en Listas nacionales o internacionales ( prevención del lavado de
                    activos y financiación del terrorismo)</p>
                </div>
                <div class="completeBullet">
                  <i class="fa fa-check" aria-hidden="true"></i>
                  <p class="regular">Recomendaciones que puedes tener en cuenta para hacer mejores negocios.</p>
                </div>
              </div>
              <a (click)="irVerifica()" class="btn-midc btn-orange h-lg-btn w-100-btn verifica-modal"
                id="planVerificaModal" webActivity data-idtag="Freemium" data-nametag="planVerificaModal"
                data-bs-dismiss="modal" aria-label="Close">
                <span class="verifica-modal">Verificar a otra persona</span>
                <i class="fa fa-chevron-right verifica-modal" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Modal Verifica -->

<!-- Modal Intermitencia -->
<div class="modal fade hide" id="modalIntermitencia" tabindex="-1" role="dialog" aria-labelledby="planPerfilModalLabel"
  aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog plansModal modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
      </div>
      <div class="modal-body">
        <div class="container">
          <div class="row">
            <div class="col-12 col-md-6 order-0 order-md-0 mb-3 align-self-center">
              <img src="assets/img/modals/alert-claims/icono_modal_fin.svg" class="img-plan"
                alt="Plan Freemium" appLazyLoadImg/>
            </div>
            <div class="col-12 col-md-6 order-1 order-md-1">
              <div class="add" [innerHTML]="sesion.messageIntermittence"></div>
              <a routerLink="/" class="btn-midc btn-orange h-lg-btn w-100-btn" data-bs-dismiss="modal" aria-label="Close" (click)="closeIntermitencia()">
                <span>Aceptar</span>
                <i class="fa fa-chevron-right" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Modal Intermitencia -->

<!-- Modal Error -->
<div class="modal fade hide" id="modalErrorCampaign" tabindex="-1" role="dialog"
  aria-labelledby="ErrorCampaignModalLabel" aria-hidden="true">
  <div class="modal-dialog plansModal modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="container">
          <div class="row">
            <div class="col-12 col-md-6 order-0 order-md-0 mb-3 align-self-center">
              <img src="assets/img/landings/sodimac/Envio_negativo.svg" class="img-plan" alt="Plan Freemium"  appLazyLoadImg/>
            </div>
            <div class="col-12 col-md-6 order-1 order-md-1">
              <p class="title-plan">¡Mantenimiento en nuestros Canales!</p>
              <p class="add">La funcionalidad de <b>Creación y Consulta de reclamos</b> estará inactiva por
                mantenimiento:</p>
              <p class="add">Desde el <ins>20 de Febrero a las 2pm</ins> hasta las <ins>12am del 21 de Febrero</ins></p>
              <p class="add">Disfruta de todos los otros servicios que <b>Mi Datacrédito</b> tiene para ti</p>
              <a class="btn-midc btn-orange h-lg-btn w-100-btn" data-bs-dismiss="modal" aria-label="Close">
                <span>Aceptar</span>
                <i class="fa fa-chevron-right" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Modal Error -->

<!-- Modal Aceptación publicidad TimeOut  -->
<div class="modal fade hide" id="accepAdvrModal" tabindex="-1" role="dialog" aria-labelledby="accepAdvrModalLabel"
  aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog claimsModal modal-dialog-centered" role="document">
    <div class="modal-content advert">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body advert">
        <div class="container">
          <div class="row">
            <div class="col-12 col-md-6 align-self-center">
              <img src="assets/img/freepremium/publicidad/icono_envio_comunicacion.svg" alt="Alerta Notificaciones"
                class="img-claim advert" appLazyLoadImg/>
            </div>
            <div class="col-12 col-md-6">
              <p class="title-modal advert">¡Mantente informado de todo lo que MiDatacrédito tiene para ti!</p>
              <p>Recibe noticias y promociones personalizadas vía correo y celular.</p>
              <a target="_blank" class="btn-midc btn-orange h-lg-btn w-100-btn" id="aceptacionPublicidadModal"
                webActivity data-idtag="envioCorreosMDC" data-nametag="aceptacionPublicidadModal" data-bs-dismiss="modal"
                aria-label="Close">
                <span>Aceptar</span>
                <i class="fa fa-chevron-right" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Modal Aceptación publicidad TimeOut  -->

<!-- Modal Alerta Intento Suplantacion  -->
<div class="modal fade hide" id="alert-impersonation" tabindex="-1" role="dialog"
  aria-labelledby="alert-impersonation-Label" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog claimsModal modal-dialog-centered" role="document">
    <div class="modal-content advert">
      <div class="modal-body advert">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <p>Como Titular de la información en caso de considerar ser víctima del delito de falsedad personal y/o
                suplantación de identidad, y le sea exigido el pago de obligaciones como resultado de ese delito, podrá
                registrar en su historia de crédito una leyenda que diga “victima de Falsedad Personal”. Así mismo, le
                recomendamos acercarse directamente a la entidad en particular (Fuente) y presentar una solicitud de
                corrección en la cual manifieste la situación de la cual es víctima adjuntando los soportes o documentos
                correspondientes. Lo anterior, de conformidad con lo establecido en el numeral 7 Item II del artículo 16
                de la Ley 1266 de 2008.</p>
              <a class="btn-midc btn-orange h-lg-btn w-100-btn" data-bs-dismiss="modal" aria-label="Close">
                <span>Entendido</span>
                <i class="fa fa-chevron-right" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Modal Alerta Intento Suplantacion  -->
<!-- Modal Creacion Reclamacion -->
<div class="modal fade hide" id="sendSMSModal" tabindex="-1" role="dialog" aria-labelledby="sendSMSModal"
  aria-hidden="true">
  <div class="modal-dialog okReclamacion modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="container">
          <div class="row">
            <div class="col-12 col-md-6 align-self-center">
              <img *ngIf="content.okSendSMS" src="assets/img/modals/alert-claims/ok-reclamacion.svg"
                alt="Alerta Notificaciones" class="img-claim" appLazyLoadImg/>
              <img *ngIf="!content.okSendSMS" src="assets/img/images/img_webcheckout_bad.svg"
                alt="Alerta Notificaciones" class="img-claim nok" appLazyLoadImg/>
            </div>
            <div class="col-12 col-md-6">
              <p class="title-reclamacion" *ngIf="content.okSendSMS">¡Tu código ha sido enviado exitosamente!</p>
              <p class="title-reclamacion" *ngIf="!content.okSendSMS">No pudimos enviar tu código satisfactoriamente</p>
              <div class="box">
                <p *ngIf="content.okSendSMS">
                  Verifica tu dispositivo
                </p>
                <p *ngIf="!content.okSendSMS">Hay un error en la información proporcionada</p>
              </div>
              <a target="_blank" class="btn-midc btn-orange h-lg-btn w-100-btn" data-bs-dismiss="modal" aria-label="Close">
                <span *ngIf="content.okSendSMS">Entendido</span><span *ngIf="!content.okSendSMS">Intentar de
                  nuevo</span>
                <i class="fa fa-chevron-right" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Modal Creacion Reclamacion -->
<!-- Modal Ponte al Dia YA  -->
<div class="modal fade hide" id="pdaYaModal" tabindex="-1" role="dialog" aria-labelledby="pdaYaModalLabel"
  aria-hidden="true">
  <div class="modal-dialog claimsModal modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="container">
          <div class="row h-420">
            <div class="col-12 col-md-6 left-side">
              <button type="button" class="close-padya d-block d-md-none" data-bs-dismiss="modal" aria-label="Close">
                <img src="assets/img/modals/padYA/Cerrar_Mobile_PADYA.svg" alt="cerrar" title="cerrar" appLazyLoadImg/>
              </button>
              <!-- <img src="assets/img/modals/padYA/D_modal_PADYA.png" alt="Modal padya" class="img-claim" /> -->
              <!-- imagen -->
              <div class="box-info">
                <img src="assets/img/modals/padYA/Informacion_PADYA.svg" alt="alert padya" title="alert padya" appLazyLoadImg/>
                <p>Tomar el <b>control de tu vida financiera</b>, nunca fue tan <u>fácil</u>.</p>
              </div>
            </div>
            <div class="col-12 col-md-6 right-side">
              <button type="button" class="close-padya d-none d-md-block" data-bs-dismiss="modal" aria-label="Close">X</button>
              <div class="content-padya">
                <h3><b>{{sesion.user?.nombre}}</b>, así puedes <u>Ponerte al día</u>:</h3>
                <div class="steps-padya">
                  <div class="bullet-padya" *ngFor="let instruction of content.paymentInstructionsPadYA">
                    <div class="bullet-list"></div>
                    <div class="content-list" [innerHTML]="instruction">
                    </div>
                  </div>
                </div>
                <button target="_blank" class="btn-midc btn-orange h-lg-btn w-100-btn" (click)="redirectPadYa()"
                  id="btnNegociacionPadya" data-bs-dismiss="modal" aria-label="Close">
                  <span *ngIf="!isLoadApplyPadYa">{{content.ctaPadYa}}</span>
                  <i class="fa fa-chevron-right" aria-hidden="true" *ngIf="!isLoadApplyPadYa"></i>
                  <span class="custom-loader" *ngIf="isLoadApplyPadYa" ></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Modal Ponte al Dia YA  -->

<!-- Modal Freemium  -->
<div class="modal bd-example-modal-lg fade modalFreemium" tabindex="-1" role="dialog" aria-labelledby="freemiumModal" aria-hidden="true" id="freemiumModal">
    <div class="modal-dialog modal-dialog-centered mDialog" role="document">
        <div class="modal-content mContent">
            <div class="modal-body boxModal">
                <button type="button" data-bs-dismiss="modal" aria-label="Close" class="closeM">&times;</button>
                <div class="contModal">
                    <div class="cabecera">
                    </div>
                    <div class="boxSide">
                        <h3>¡Ahora puedes conocer tu <b>Puntaje de Crédito!</b></h3>
                        <div class="item">
                            <p class="txt">Queremos darte todas las herramientas para que tomes el control de tu vida financiera. <br><br>
                               Por esto <b>POR TIEMPO LIMITADO</b> podrás conocer tu puntaje de crédito sin costo o alguna suscripción.</p>
                        </div>
                        <div class="boxBenefit">
                          <h6>Algunos <span>BENEFICIOS</span> de nuestros planes:</h6>
                          <div class="boxPri">
                            <div class="opt">
                                <img src="https://d1frrugl4zkdua.cloudfront.net/midc/icons/white/Puntaje.png" alt="benefit"/>
                                <p>Puntaje ilimítado.</p>
                            </div>
                            <div class="opt">
                                <img src="https://d1frrugl4zkdua.cloudfront.net/midc/icons/white/AlertasSistema.png" alt="benefit"/>
                                <p>Alertas antifraude.</p>
                            </div>
                            <div class="opt">
                                <img src="https://d1frrugl4zkdua.cloudfront.net/midc/icons/white/Diagnostico.png" alt="benefit"/>
                                <p>Diagnóstico.</p>
                            </div>
                          </div>
                          <p class="txt">y <span>MUCHO</span> más.</p>
                        </div>
                        <button data-bs-dismiss="modal" aria-label="Close">Ver mi PUNTAJE</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--Fin Modal Freemium  -->
<!-- Modal PAD serlefin MVP  -->
<div class="modal fade hide" id="padModalSerlefin" tabindex="-1" aria-labelledby="padModalSerlefinLabel" data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog claimsModal modal-dialog-centered" >
    <div class="modal-content">
      <div class="modal-header">
        <img class="d-md-block d-none" src="assets/img/modals/padYA/D_Modal_SerlefinMVP_Confondo.png" alt="serlefin" title="serlefin"/>
        <img class="d-md-none d-block" src="assets/img/modals/padYA/M_Modal_SerlefinMVP_Confondo.png" alt="serlefin" title="serlefin"/>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModalSerlefin()">
          <img src="assets/img/icons/icono_cerrar.svg" alt="cerrar" title="cerrar" />
        </button>
      </div>
      <div class="modal-body">
        <div class="container">
          <div class="row h-420">
            <div class="col-12">
              <h3 *ngIf="!failIntention">¡Genial!</h3>
              <h3 *ngIf="failIntention">¡Ups! Algo salió mal.</h3>
              <p *ngIf="!failIntention">Ahora te enviaremos a iniciar el proceso de negociación de esta obligación con nuestro <b>aliado</b>.</p>
              <p *ngIf="failIntention">No pudimos iniciar el proceso de negociación de esta obligación con nuestro <b>aliado</b>. Por favor, intenta nuevamente más tarde.</p>
              <button target="_blank" class="btn-midc btn-orange h-lg-btn w-100-btn" 
                  (click)="applyIntentionPad()">
                 <span *ngIf="!isLoadSaveIntention">{{(failIntention ? 'Cerrar' : 'Continuar')}}</span>
                 <span class="custom-loader" *ngIf="isLoadSaveIntention" ></span>
                </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--Fin Modal PAD serlefin MVP  -->
<!--INICIO MODAL CONFIRMACION TELEFONO-->
<div class="modal fade hide" id="modalConfirmaTel" [ngClass]="{'flow-pad':content.flowConfirmTelephone == 'pad'}"  tabindex="-1"
	 data-bs-backdrop="static">
	<div class="modal-dialog modal-dialog-centered" >
		<div class="modal-content">
			<div class="modal-body">
				<div class="container">
					<button class="close-confirm-tel" (click)="closeConfirmTel()">
						<span>&times;</span>
					</button>
					<div class="row">
						<div class="col-6 left-side d-none d-md-block img-modal-desktop">
						</div>
						<div class="col-12 left-side d-block d-md-none">
							<div class="img-plan">
							</div>
						</div>
						<div class="col-12 col-md-6 right-side">
							<app-confirm-telephone></app-confirm-telephone>							
						</div>
					</div>					
				</div>
			</div>
		</div>
	</div>
</div>
<!--FIN MODAL CONFIRMACION TELEFONO-->